import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useSessionManager } from '@/hooks/useSessionManager';

/**
 * 新建会话按钮。
 */
const NewSessionButton: React.FC = () => {
  const { createAndSwitchSession } = useSessionManager();

  return (
    <Button
      fullWidth
      variant="contained"
      startIcon={<AddIcon />}
      onClick={createAndSwitchSession}
      sx={{
        justifyContent: 'flex-start',
        py: 1,
        borderRadius: 2,
        textTransform: 'none',
      }}
    >
      新建会话
    </Button>
  );
};

export default NewSessionButton;
